import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { TitleStrategy } from '@angular/router';
import { I18nTitleStrategyService } from '../shared/services/i18n-title-strategy.service';

export function provideTitleStrategy(): EnvironmentProviders {
  return makeEnvironmentProviders([
    {
      provide: TitleStrategy,
      useClass: I18nTitleStrategyService,
    },
  ]);
}
